import { render, staticRenderFns } from "./OauthCode.vue?vue&type=template&id=bab644e8"
import script from "./OauthCode.vue?vue&type=script&lang=js"
export * from "./OauthCode.vue?vue&type=script&lang=js"
import style0 from "./OauthCode.vue?vue&type=style&index=0&id=bab644e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports